import {
  getServiceData,
  getLpuData,
  getDoctorData,
  getDoctorsData,
  getEquipmentsData,
  getAppointmentRegistrationTypes,
  getAppointmentObjectTypes,
  getInitCalendarCommonData,
  getInitCalendarServicesData,
  getInitCalendarDoctorData,
  getInitAdditionalData,
  getInitUserData,
  getUrlsData,
  getInitAppointmentStatusData,
  getInitClubStatusData,
  getAppointmentCallTimes,
  getInitPreliminaryConsultationData,
} from 'www/vue_components/common/AppointmentPage/interfaces'

const AppointmentPageContextProps = {
  props: {
    initUserData: {
      type: Object,
      default: getInitUserData,
    },
    serviceData: {
      type: Object,
      default: getServiceData,
    },
    lpuData: {
      type: Object,
      default: getLpuData,
    },
    doctorData: {
      type: Object,
      default: getDoctorData,
    },
    doctorsData: {
      type: Array,
      default: getDoctorsData,
    },
    equipmentsData: {
      type: Array,
      default: getEquipmentsData,
    },
    initPreliminaryConsultationData: {
      type: Object,
      default: getInitPreliminaryConsultationData,
    },
    appointmentRegistrationTypes: {
      type: Object,
      default: getAppointmentRegistrationTypes,
    },
    appointmentObjectTypes: {
      type: Object,
      default: getAppointmentObjectTypes,
    },
    appointmentCallTimes: {
      type: Object,
      default: getAppointmentCallTimes,
    },
    initCalendarData: {
      type: Object,
      default: () => ({
        ...getInitCalendarCommonData(),
        ...getInitCalendarServicesData(),
        ...getInitCalendarDoctorData(),
      }),
    },
    initAdditionalData: {
      type: Object,
      default: getInitAdditionalData,
    },
    urls: {
      type: Object,
      default: getUrlsData,
    },
    initAppointmentStatusData: {
      type: Object,
      default: getInitAppointmentStatusData,
    },
    initClubStatusData: {
      type: Object,
      default: getInitClubStatusData,
    },
    isAppointmentByReferral: {
      type: Boolean,
      default: false,
    },
  },
}

export default AppointmentPageContextProps
